import React from 'react';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {TagSmall} from '@wix/wix-ui-icons-common';
import {CartItemDataHook} from '../../CartItem';
import s from '../../CartItem.scss';
import {classes} from '../../CartItem.st.css';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';

export const ItemDiscounts = ({lineItem}: {lineItem: LineItemModel}) => {
  const {couponAlignmentInCartAndCheckout} = useControllerProps().cartStore;
  const shouldShowNewDiscounts = couponAlignmentInCartAndCheckout && lineItem.discounts?.length > 0;

  return shouldShowNewDiscounts ? (
    <div data-hook={CartItemDataHook.Discounts} className={classes.discountsRoot}>
      {lineItem.discounts?.map(({name}, index: number) => (
        <div key={`name-${index}`} className={classes.discountTag}>
          <TagSmall data-hook={CartItemDataHook.DiscountIcon} className={classes.discountIcon} />
          <Text data-hook={CartItemDataHook.DiscountName} className={classes.discountNameText}>
            {name}
          </Text>
        </div>
      ))}
    </div>
  ) : (
    <div data-hook={CartItemDataHook.DiscountsOld}>
      {lineItem.discounts?.map(({name}, index: number) => (
        <div
          key={`${CartItemDataHook.DiscountName}-${index}`}
          data-hook={`${CartItemDataHook.DiscountName}-${index}`}
          className={s.discountName}>
          {name}
        </div>
      ))}
    </div>
  );
};
